import { createFileRoute } from '@tanstack/react-router';

import { OrdersPage } from '@/features/procurement/orders-page';

export const Route = createFileRoute('/_app/projects/$projectId/procurement/orders/')({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();
  return <OrdersPage {...params} />;
}
